import {
  RECETADIGITAL_SUCCESS,
  RECETADIGITAL_LOADING,
  RECETADIGITAL_ERROR,
  RECETADIGITAL_RESET,
  RECETADIGITAL_SETERRORUSUARIO,
  RECETADIGITAL_SETRECETA,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import recetasDigitalesInitialState from "../initialStates/recetasDigitalesInitialState";

const recetasDigitales = (state, { payload, type }) => {
  switch (type) {
    case RECETADIGITAL_SETRECETA:
      return {
        ...state,
        recetasDigitales: {
          ...state.recetasDigitales,
          receta: payload,
        },
      };
    case RECETADIGITAL_LOADING:
      return {
        ...state,
        recetasDigitales: {
          ...state.recetasDigitales,
          error: false,
          loading: true,
        },
      };
    case RECETADIGITAL_SUCCESS:
      return {
        ...state,
        recetasDigitales: {
          ...state.recetasDigitales,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case RECETADIGITAL_ERROR:
      return {
        ...state,
        recetasDigitales: {
          ...state.recetasDigitales,
          error: payload,
          loading: false,
        },
      };
      case RECETADIGITAL_SETERRORUSUARIO:
      return {
        ...state,
        recetasDigitales: {
          ...state.recetasDigitales,
          listErrorReceta: payload,
        },
      };

    case RECETADIGITAL_RESET:
      return recetasDigitalesInitialState;
    case RESET_PORTAL_CONTEXT:
      return recetasDigitalesInitialState;

    default:
      return state;
  }
};

export default recetasDigitales;
